import { InternalConnection } from "@shared/constants";
import { TenantConnectionConfig } from "@shared/utils";

export const config: TenantConnectionConfig<InternalConnection | undefined> = {
  ig: {
    prod: "ig-ad", // keep undefined for local dev and staging we dont need to defined an SSO
    qa: "ig-ad-qa", // keep undefined for local dev and staging we dont need to defined an SSO
    staging: undefined, // keep undefined for local dev and staging we dont need to defined an SSO
    demo: "ig-ad-qa",
  },
  "ig-dev": {
    prod: undefined,
    qa: "ig-ad-dev",
    staging: "ig-ad-dev",
    demo: "ig-ad-dev",
  },
  nesto: {
    prod: undefined,
    qa: undefined,
    staging: undefined,
    demo: undefined,
  },
  cmls: {
    prod: undefined,
    qa: undefined,
    staging: undefined,
    demo: undefined,
  },
  td: {
    prod: undefined,
    qa: undefined,
    staging: undefined,
    demo: undefined,
  },
};
